import React, { Component, Fragment } from 'react'
import Breadcrumb from 'react-bootstrap/Breadcrumb'
import { Container,Row,Col, Form,Button } from 'react-bootstrap'
import Product1 from '../../assets/images/product/servivesproducts.png'



import { Link } from 'react-router-dom';
class About_us extends Component {
     render() {
          return (
               <Fragment>
              <Container fluid={true}  className="BetweenTwoSection">
        


              <div className="breadbody">
               <Breadcrumb>
  <Breadcrumb.Item> <Link to="/"> Home </Link> </Breadcrumb.Item>
  <Breadcrumb.Item> <Link to="/about"> About Us </Link> </Breadcrumb.Item>   
</Breadcrumb>
</div>
<h2 className="section-title text-center mb-2 text-primary">  WELCOME TO CHRISALPHA TECH COMPANY LTD</h2>

<p className="text-center mb-3">  Empowering Businesses Through Smart Technology Solutions</p>
                   <Row className="">
<Col className="shadow-sm bg-white pb-3 mt-4" md={12} lg={12} sm={12} xs={12}>
     <Row>
          
               

 <Col className="p-3" md={6} lg={6} sm={12} xs={12}>
          <img className="w-100" src={Product1} />
          <Container  className="my-3">
               
<h6 className="mt-2"><strong>Why Choose CHRISALPHA TECH COMPANY LTD</strong></h6>
          <ul>
          <li>Professional and experienced technical team</li>
          <li>Reliable and secure software solutions</li>
          <li>Affordable pricing</li>
          <li>Fast customer support</li>
          <li>Customized solutions for different businesses</li>
          <li>Commitment to quality and customer satisfaction</li>
          </ul>

          </Container>
          </Col>
          <Col className="p-3 " md={6} lg={6} sm={12} xs={12}>
            <h4>Company Overview</h4>
          
          <p>


CHRISALPHA TECH COMPANY LTD is a professional software development and information technology company dedicated to
 delivering high-quality digital solutions. The company specializes in the design, development, and implementation of 
 reliable and scalable software systems tailored for businesses, organizations, and institutions.




</p>

<p>

We are committed to providing innovative, efficient, and user-friendly technology and enterprise 
solutions that enable our clients to improve productivity, streamline operations, and enhance overall customer experience. 
Through a combination of technical expertise and a deep understanding of business needs, we strive to deliver solutions
 that drive growth and long-term success.

</p>

 <h6 className="section-sub-title fw-bold">Our Mission</h6>
          <p>To provide reliable, innovative, and affordable software and IT solutions that empower businesses to operate efficiently and grow successfully.</p>

              
 <h4 className="section-sub-title fw-bold"> Our Vision </h4>
<p>To become a leading technology solutions provider in Uganda and across Africa, recognized for quality, innovation, and excellent customer service.</p>
      
          <div className="">

          <p>At Chrisalpha Tech, we are committed to delivering reliable,
scalable, and user-friendly technology solutions. Our goal is to empower businesses with tools that improve efficiency, enhance customer experience, and increase profitability.
We combine innovation, technical expertise, and a deep
 understanding of business needs to create solutions that make a real impact.</p>

          </div>
           <h4 className="section-sub-title fw-bold">Our Products</h4>
        <ol>
     <li>
     <strong>PARKEASE:</strong> Parking and WashBay Management App
     </li>

     <li>
     <strong>POSPRESSO:</strong> Restaurant & Bars Point Of Sale (POS)
     </li>

     <li>
     <strong>POSPRESSO PLUS:</strong> Restaurant & Bars POS with Parking and WashBay App
     </li>

     <li>
     <strong>CAT HOMIS:</strong> Hotel Management Information App
     </li>

     <li>
     <strong>TRADE HUB:</strong> POS Purchase & Inventory Management App
     </li>
   </ol>
          </Col>
     </Row>

     <Row>
          <Col className="" md={6} lg={6} sm={12} xs={12}>
     
          
 <h6 className="section-sub-title fw-bold">Our Services</h6>
          <ul>
          <li>Website Design and Development</li>
          <li>Website and Email Hosting</li>
          <li>Computer Repair and Maintenance</li>
          <li>Computer Networking Installation and Support</li>
          <li>Software Development and System Implementation</li>
          <li>IT Support and Technical Consulting</li>
          </ul>
          </Col>

          <Col className="" md={6} lg={6} sm={12} xs={12}>
                 
<div className="video-container">
  <iframe
    width="90%"
    height="250"
    src="https://www.youtube.com/embed/RmfcGoXvMXc"
    title="YouTube video player"
    frameBorder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
    referrerPolicy="strict-origin-when-cross-origin"
    allowFullScreen
  ></iframe>
</div>
    

          </Col>







     </Row>
</Col>
                   </Row>
               </Container>
               
               </Fragment>
          )
     }
}

export default About_us